import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.updateFreeShippingBarFromCart();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
    this.updateFreeShippingBarFromCart();
  };

  open() {
    this.showDialog();
    this.updateFreeShippingBarFromCart();
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }

  updateFreeShippingBar(cartTotal) {
    const bar = document.getElementById('free-shipping-bar');
    if (!bar) return;
    const freeShippingMin = parseFloat(bar.dataset.freeShippingMin) / 100; // Convert cents to dollars
    const text = bar.querySelector('#free-shipping-text');
    const progress = bar.querySelector('#free-shipping-progress');
    if (!text || !progress) return;
    const falta = freeShippingMin - cartTotal;
    const remainingText = bar.dataset.textRemaining || 'Only $%{amount} for free shipping';
    const earnedText = bar.dataset.textEarned || 'You have earned Free Shipping!';
    let message;
    if (falta > 0) {
      message = remainingText.replace('%{amount}', falta.toFixed(2));
    } else {
      message = earnedText;
    }
    text.textContent = message;
    let percent = Math.min((cartTotal / freeShippingMin) * 100, 100);
    progress.style.width = percent + '%';
  }

  updateFreeShippingBarFromCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        this.updateFreeShippingBar(cart.total_price / 100);
      });
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}